let imageSearchProvider = ''

export function setImageSearchProvider(value: string): void {
  imageSearchProvider = value
}

export function getImageSearchProvider(): string {
  return imageSearchProvider
}
